//React doesn't like to render String HTML, this code helps.
export const htmlDecode = (input: string) => {
  const e = document.createElement("div");
  e.innerHTML = input;

  if (e.childNodes.length === 0) {
    throw new Error("An error has occurred.");
  }

  return Array.from(e.childNodes)
    .map((childNode) => childNode.nodeValue)
    .join(" ");
};

export const formatDate = (inputDate: string): string => {
  const date = new Date(inputDate);
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  };

  return date.toLocaleDateString("en-US", options);
};

export const getUrlJobPostingId = (el?: HTMLDivElement): string | undefined => {
  const attr = el?.getAttribute("job-id");

  if (attr) {
    return attr;
  }

  const matches =
    window.location.pathname.match(/^\/careers\/openings\/(\d+)\/?($|\w+)/i) ||
    [];

  if (matches.at(1)) {
    return matches.at(1);
  }

  return new URLSearchParams(location.search).get("gh_jid") || undefined;
};
